import { Random } from 'excalibur';
import { Theme } from './skins';
import { css, drawTaperedStroke, paintClockBase, wobblyCirclePath } from '../utils/sketch';

export function paintSkinPreview(
  ctx: CanvasRenderingContext2D,
  rng: Random,
  theme: Theme,
  radius: number,
): void {
  const palette = theme.palette;

  ctx.save();
  ctx.globalAlpha = 0.12;
  ctx.fillStyle = css(palette.shadow, 1);
  for (let i = 0; i < 3; i++) {
    wobblyCirclePath(ctx, 5, 8 + i * 4, radius + 6 + i * 5, rng, 3, 40);
    ctx.fill();
  }
  ctx.restore();

  paintClockBase(ctx, 0, 0, rng, {
    radius,
    faceLight: palette.cream,
    faceShade: palette.paperDeep,
    rim: palette.ink,
    tick: palette.ink,
    accents: [palette.mint, palette.yellow, palette.pink, palette.blue],
  });

  ctx.save();
  ctx.rotate(-0.5);
  drawTaperedStroke(ctx, rng, 0, radius * 0.1, -radius * 0.68, radius * 0.05, palette.blue, palette.blueDeep);
  ctx.restore();

  ctx.save();
  ctx.rotate(2.2);
  drawTaperedStroke(ctx, rng, 0, radius * 0.08, -radius * 0.48, radius * 0.065, palette.pink, palette.pinkDeep);
  ctx.restore();

  ctx.save();
  ctx.fillStyle = css(palette.cream, 1);
  wobblyCirclePath(ctx, 0, 0, radius * 0.075, rng, 1, 16);
  ctx.fill();
  ctx.strokeStyle = css(palette.ink, 0.9);
  ctx.lineWidth = 2;
  ctx.stroke();
  ctx.restore();

  const eyeDx = radius * 0.3;
  const eyeY = -radius * 0.1;
  const eyeR = radius * 0.095;
  for (const side of [-1, 1]) {
    ctx.save();
    ctx.fillStyle = css(palette.cream, 1);
    wobblyCirclePath(ctx, side * eyeDx, eyeY, eyeR, rng, 0.7, 16);
    ctx.fill();
    ctx.strokeStyle = css(palette.ink, 0.9);
    ctx.lineWidth = 1.6;
    ctx.stroke();
    ctx.fillStyle = css(palette.ink, 0.9);
    ctx.beginPath();
    ctx.arc(side * eyeDx, eyeY + eyeR * 0.22, eyeR * 0.45, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  ctx.save();
  ctx.strokeStyle = css(palette.ink, 0.9);
  ctx.lineWidth = Math.max(1.6, radius * 0.03);
  ctx.lineCap = 'round';
  ctx.beginPath();
  ctx.arc(0, radius * 0.16, radius * 0.22, Math.PI * 0.22, Math.PI * 0.78);
  ctx.stroke();
  ctx.restore();

  ctx.save();
  ctx.fillStyle = css(palette.blue, 0.9);
  wobblyCirclePath(ctx, 0, -radius + 5, radius * 0.075, rng, 1, 14);
  ctx.fill();
  ctx.restore();
}
